import React from "react";

import { appConfig } from "@/config/app";

/**
 * Sets the browser tab title — "Page Name | App Name" for a specific page,
 * or just the app name when called with no argument (a true landing page
 * with nothing more specific to show). Standard across every Scouting Ops
 * app; each routed page calls this once. index.html's own static <title>
 * (matching appConfig.name) covers the brief pre-hydration flash, and any
 * page that forgets to call this just keeps showing that default rather
 * than something broken.
 */
export function usePageTitle(title?: string): void {
  React.useEffect(() => {
    document.title = title ? `${title} | ${appConfig.name}` : appConfig.name;
  }, [title]);
}
